import React from 'react';
import './Eficiencia.css';

function Eficiencia() {
  return (
    <section className="partners_limit">
      <h1>
        Estamos entre as maiores empresas de serviços em tecnologia
        do Norte do Paraná. Uma das únicas a cumprir 100% dos projetos entregues.
      </h1>
    </section>
  );
}

export default Eficiencia;
